<template>
  <div :class="$style.root">
    <button
      v-for="rating in ratings"
      :key="rating"
      :class="{
        [$style.button]: true,
        [$style.isActive]: value === rating,
        [$style.isDisabled]: disabled,
      }"
      :disabled="disabled"
      @click="clickHandler(rating)"
    >
      <UiIcon
        :class="$style.icon"
        :style="stylesIcon"
        :color-inheritance="true"
        name="star"
      />
      {{ rating }}
    </button>
  </div>
</template>

<script>
  import { range } from '@/utils';
  import UiIcon from '@/components/UiIcon';

  export default {
    name: 'UiRating',
    components: {
      UiIcon,
    },
    model: {
      prop: 'value',
      event: 'change',
    },
    props: {
      value: {
        type: Number,
        default: null,
      },
      maxRating: {
        type: Number,
        default: 5,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      size: {
        type: [String, Number],
        default: 1,
        validate: (_) => Number(_) > 0,
      },
    },
    computed: {
      ratings() {
        return range(this.maxRating, 0);
      },
      stylesIcon() {
        return {
          fontSize: `${this.size}em`,
        };
      },
    },
    methods: {
      clickHandler(rating) {
        this.$emit('change', rating);
      },
    },
  };
</script>

<style lang="scss" module>
  .root {
    display: inline-block;
    user-select: none;
  }

  .button {
    @include resetButton;
    color: $colorGrayDark2;
    transition: $primaryTransition;
    float: right;

    &:hover,
    &:hover ~ &,
    &:hover ~ &.isActive,
    &:hover ~ &.isActive ~ & {
      color: lighten($colorWarning, 20%) !important;
    }

    &.isActive,
    &.isActive ~ & {
      color: $colorWarning;

      .root:hover &:not(.isDisabled) {
       color: $colorGrayDark2;
      }

      &.isDisabled {
        color: lighten($colorWarning, 10%);
      }
    }

    &.isDisabled {
      color: lighten($colorGrayDark2, 10%);
      pointer-events: none;
    }

    & + & {
      padding-right: 8px;
    }
  }

  .icon {
    font-size: 1em;
  }
</style>
